import React from 'react';
import { LuScanFace, LuMessageSquare } from 'react-icons/lu';
import SegmentedSwitch from '../oracle/SegmentedSwitch';
import PageHeader from '../oracle/PageHeader';
import { COPY } from '../../contracts/copyMap';

// Vault page header (/vault, both sub-tabs). The title layout comes from
// PageHeader; this contributes the sub-tab controls — a SCANS/GLOWUPS pill
// switch on the right at desktop, a full-width underline tab row on mobile.
// The mobile title carries no subtitle: the tab row sits directly beneath it.
//
// Props:
//   tab          'scans' | 'glowups'
//   onTabChange  (key) => void

const GlowupsGlyph = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 4v16 M4 8h4v8H4z M16 8h4v8h-4z" />
  </svg>
);

// A header-level tab row — unrelated to the BottomTabBar's 4-tab cap, which
// governs primary navigation only.
const TAB_OPTIONS = [
  { key: 'scans', label: 'SCANS', icon: <LuScanFace size={16} /> },
  { key: 'glowups', label: 'GLOWUPS', icon: GlowupsGlyph },
  { key: 'feedback', label: COPY.FEEDBACK_GIVEN_TAB, icon: <LuMessageSquare size={16} /> },
];

const VaultHeader = ({ tab = 'scans', onTabChange }) => (
  <PageHeader
    title="VAULT"
    subtitle={COPY.VAULT_SUBTITLE}
    mobileSubtitle={null}
    desktopRight={(
      <div className="mt-1.5">
        <SegmentedSwitch options={TAB_OPTIONS} active={tab} onChange={onTabChange} />
      </div>
    )}
    mobileExtra={(
      <div
        className="flex mt-4 -mx-5 border-b border-hairline-soft"
        role="tablist"
        aria-label="vault sections"
      >
        {TAB_OPTIONS.map((opt) => {
          const active = opt.key === tab;
          return (
            <button
              key={opt.key}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onTabChange && onTabChange(opt.key)}
              className={[
                'flex-1 text-center py-3 bg-transparent cursor-pointer',
                'font-display uppercase tracking-[0.22em] text-[13px]',
                'border-0 border-b-2 transition-colors duration-200 ease-mogged',
                active
                  ? 'text-aurum-bright border-aurum'
                  : 'text-bone-dim border-transparent',
              ].join(' ')}
              style={{ borderBottomStyle: 'solid' }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    )}
  />
);

export default VaultHeader;
